document.addEventListener("DOMContentLoaded", () => {

  if (typeof Swiper === "undefined") return;

  document.querySelectorAll(".mg-slider").forEach((slider) => {

    const progress = slider.querySelector(".progress-fill");
    const current = slider.querySelector(".current");
    const total = slider.querySelector(".total");

    let raf;

    function stopProgress() {
      cancelAnimationFrame(raf);
      progress.style.width = "0%";
      progress.style.transition = "none";
    }

    function startProgress(delay) {

      stopProgress();

      const start = performance.now();

      function frame(now) {

        const percent = Math.min(((now - start) / delay) * 100, 100);

        progress.style.width = percent + "%";

        if (percent < 100) {
          raf = requestAnimationFrame(frame);
        }

      }

      raf = requestAnimationFrame(frame);

    }

const swiper = new Swiper(slider.querySelector(".mgSwiper"), {
  loop: true,
  speed: 800,

  pagination: {
    el: slider.querySelector(".swiper-pagination"),
    clickable: true,
  },

  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
});

    function update(swiper) {

      current.textContent = swiper.realIndex + 1;

      swiper.slides.forEach((slide) => {

        slide.querySelectorAll("video").forEach((video) => {

          video.pause();

        });

      });

      const active = swiper.slides[swiper.activeIndex];

      const activeVideo = active.querySelector("video");

      if (activeVideo) {

        activeVideo.currentTime = 0;

        activeVideo.play().catch(() => {});

      }

      // Swiper automatically reads this attribute
      const delay =
        Number(active.dataset.swiperAutoplay) || 5000;

      startProgress(delay);

    }
    document.addEventListener("shopify:block:select", (e) => {

      const slide = e.target.closest(".swiper-slide");

      if (!slide) return;

      swiper.slideToLoop([...slide.parentNode.children].indexOf(slide));

    });

  });

});